/* ELVETH — Carosello foto della product card al passaggio del mouse.
   Il tema (SecondaryMedia in theme.js) gestisce solo 2, 3 o 4 foto: con più
   immagini il mouse non faceva scorrere nulla. Qui la stessa logica vale per
   qualsiasi numero di foto: la card viene divisa in fasce verticali, una per
   ogni foto oltre la prima (la prima resta quella a riposo). */
(function () {
  var SecondaryMedia = customElements.get('secondary-media');
  if (!SecondaryMedia) return;

  SecondaryMedia.prototype.onMoveHandler = function (event) {
    if (!this.carousel || this.mediaCount < 2) return;
    if (this.mediaCount === 2) return this.carousel.select(1);

    var width = this.carousel.size.width;
    var mouseX = event.clientX - this.getBoundingClientRect().left;
    var slots = this.mediaCount - 1;
    var index = Math.floor(mouseX / (width / slots)) + 1;
    index = Math.min(Math.max(index, 1), slots);

    if (this.carousel.selectedIndex !== index) this.carousel.select(index);
  };
})();
